import { Button } from "@/common/components/ui";
import { CheckCircle } from "lucide-react";
const userIcon = "/assets/user1.svg";
const buildingIcon = "/assets/schoolgirl 1.svg";

const WhoCanRegister = () => {
  return (
    <section className="shadow-section mx-auto my-4 w-full rounded-[30px] bg-white p-4 px-4 sm:p-8 md:my-8 md:max-w-[94%] lg:my-16 lg:p-12 lg:px-10">
      <div className="container mx-auto grid gap-8 lg:gap-12">
        {/* Section Title */}
        <h2
          className="text-center font-sans text-2xl font-extrabold leading-tight text-[#1D2C56] sm:text-4xl lg:text-5xl lg:leading-[60px]"
          data-testid="text-who-can-register-title"
        >
          Who Can Register For NPS?
        </h2>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          {/* Individual Subscribers */}
          <div
            className="inline-flex w-full items-start justify-start gap-5 self-stretch rounded-[9.62px] bg-white p-4 shadow-[0px_2px_24px_0px_rgba(35,105,142,0.08)] outline outline-1 outline-offset-[-0.96px] outline-neutral-100 md:p-7"
            data-testid="card-individual-subscribers"
          >
            <div className="flex flex-col items-start gap-4 sm:flex-row sm:gap-6">
              <div className="mx-auto inline-flex h-20 w-20 items-center justify-center gap-3.5 rounded-lg bg-cyan-50 px-5 py-4 outline outline-[1.33px] outline-offset-[-1.33px] outline-slate-200">
                <img src={userIcon} alt="User" className="h-16 w-16" />
              </div>
              <div className="flex-1 text-center sm:text-left">
                <h3 className="mb-3 font-sans text-xl font-semibold text-[#2F363F] lg:text-2xl">
                  Individual Subscribers
                </h3>
                <ul className="mb-6 space-y-3 text-gray-700">
                  <li className="justify-cent flex items-start gap-3 font-sans text-[16px] text-[#707070] sm:justify-start">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#66A0CD]" />
                    <span className="font-sans text-[16px] font-medium">
                      Between 18–70 years can join
                    </span>
                  </li>
                  <li className="justify-cent flex items-start gap-3 text-[#707070] sm:justify-start">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#66A0CD]" />
                    <span className="font-sans text-[16px] font-medium">
                      Easy and multiple registration options (Aadhaar,
                      Digilocker etc.)
                    </span>
                  </li>
                  <li className="justify-ce flex items-start gap-3 text-[#707070] sm:justify-start">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#66A0CD]" />
                    <span className="font-sans text-[16px] font-medium">
                      Open Tier I (Pension A/c) and Tier II (Add-on investment
                      A/c)
                    </span>
                  </li>
                </ul>
                <Button
                  className="hover:bg-light/90 h-[50px] w-full rounded-lg bg-gradient-to-l from-[#66A0CD] to-[#1D2C56] p-4 px-6 py-3 font-sans text-lg font-bold leading-loose text-[#fff] sm:w-auto lg:text-xl"
                  data-testid="button-individual-register"
                  onClick={() => {
                    const heroSection = document.getElementById("hero-section");
                    if (heroSection) {
                      heroSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }}
                >
                  Register Now
                </Button>
              </div>
            </div>
          </div>

          {/* NPS Vatsalya (Minors) */}
          <div
            className="inline-flex items-start justify-start gap-5 self-stretch rounded-[9.62px] bg-white p-4 shadow-[0px_2px_24px_0px_rgba(35,105,142,0.08)] outline outline-1 outline-offset-[-0.96px] outline-neutral-100 md:p-7"
            data-testid="card-nps-vatsalya"
          >
            <div className="flex flex-col items-start gap-4 sm:flex-row sm:gap-6">
              <div className="mx-auto inline-flex h-20 w-20 items-center justify-center gap-3.5 rounded-lg bg-cyan-50 px-5 py-4 outline outline-[1.33px] outline-offset-[-1.33px] outline-slate-200">
                <img src={buildingIcon} alt="Building" className="h-16 w-16" />
              </div>
              <div className="flex-1 text-center sm:text-left">
                <h3 className="mb-3 font-sans text-xl font-semibold text-[#2F363F] lg:text-2xl">
                  NPS Vatsalya (Minors)
                </h3>
                <ul className="mb-6 space-y-3 text-gray-700">
                  <li className="flex items-start gap-3 text-base text-[#707070] sm:justify-start">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#66A0CD]" />
                    <span className="font-sans text-[16px] font-medium">
                      Subscriber below 18 years of age
                    </span>
                  </li>
                  <li className="flex items-start justify-center gap-3 text-base text-[#707070] sm:justify-start">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#66A0CD]" />
                    <span className="font-sans text-[16px] font-medium">
                      Easy and multiple registration options (Aadhaar,
                      Digilocker etc.)
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-base text-[#707070] sm:justify-start">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#66A0CD]" />
                    <span className="font-sans text-[16px] font-medium">
                      Applicable for NRI & OCI Subscribers also. Contributions
                      accepted from NRE/NRO A/c.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoCanRegister;
